import type { ChainId } from '@morpho-org/blue-sdk'
import type { Address } from 'viem'

import type { VaultHoldersInput, VaultHoldersOutput } from '@/lib/procedures/vaultHolders.contract'

import { orpc } from '@/lib/orpc/client'

export type VaultHoldersQueryInput = Omit<VaultHoldersInput, 'cursor'> & {
  chainId: ChainId
  address: Address
}

/** What a vault the bridge does not know shows: no holders. */
export const NO_HOLDERS: VaultHoldersOutput = {
  items: [],
  partial: false,
  nextCursor: null,
  countTotal: 0
}

/** The key the server seeds and `useVaultHoldersData` reads. */
export const vaultHoldersQueryKey = (input: VaultHoldersQueryInput) =>
  orpc.vault.holders.key({ input, type: 'infinite' })

/** The procedure's `nextCursor` page, in the `pageInfo` shape `useCursorPagination` walks. */
export function toCursorPage(page: VaultHoldersOutput) {
  return {
    ...page,
    pageInfo: { hasNextPage: page.nextCursor !== null, endCursor: page.nextCursor }
  }
}
